import { extend as _rawExtend, override as _rawOverride } from 'flarum/common/extend';
import Application from 'flarum/common/Application';
import coreFooter from './components/coreFooter';
// import addMobileElement from './components/addMobileElement';
// 2026-07-30: MobileTab 整合已撤项 (Trello #393), 不再 m.mount(MobileTab)

export default function modifyApplication() {
  // (辉哥 9/17 16:47 派 Coder 修): webpack DCE 把 const helper globals 去掉,
  // 改用 function declaration 让 helper 名字在函数体内可用
  function safeExtend(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeExtend) {
      console.warn('[ziven-core] safeExtend helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeExtend(targetOrClass, method, fn);
  }
  function safeOverride(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeOverride) {
      console.warn('[ziven-core] safeOverride helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeOverride(targetOrClass, method, fn);
  }
  safeExtend(Application, 'mount', () => {
    $("#header-navigation Navigation").off("mouseenter");
    $("#header-navigation Navigation").off("mouseleave");
    $(".DiscussionPage-list").off("mouseover");
    $(".DiscussionPage-list").off("mouseout");
    const footer = document.createElement('div');
    footer.className = "coreFooter";
    m.mount(document.body.getElementsByClassName("App-content")[0].appendChild(footer), coreFooter);

    // const mEle = document.createElement('div');
    // m.mount(document.body.appendChild(mEle), addMobileElement);
  });
}